import React, { FC } from 'react';

import { MessageInputWrapper } from '@sendbird/uikit-react/GroupChannel/components/MessageInputWrapper';

import {
  chatActiveTab,
  ClientChatTypes,
  PermissionsOfAdmin,
} from '@pharmaplan/common';
import useAdminPermissions from '../../../../hooks/Admin/useAdminPermissions';
import { useAppSelector } from '../../../../hooks/useAppSelector';

interface IMessageInput {
  isEngaged: boolean;
}

const MessageInput: FC<IMessageInput> = ({ isEngaged }) => {
  const { can } = useAdminPermissions();
  const canViewEngaged = can(PermissionsOfAdmin.ViewEngagedChat);
  const canViewUserChats = can(PermissionsOfAdmin.PharmacyProfessionalChat);

  const activeTab = useAppSelector(chatActiveTab);
  const isUsersChat = activeTab === ClientChatTypes.users;

  const viewUsersChat = canViewUserChats && isUsersChat;
  const viewEngagedChat = canViewEngaged && isEngaged;

  const isDisabled = viewUsersChat || viewEngagedChat;

  return <MessageInputWrapper disabled={isDisabled} />;
};

export default MessageInput;
